module.exports = () => ({
  ".overlay": {
    "@apply ds-fixed ds-z-50 ds-inset-0 ds-bg-primary-black/30 ds-hidden": true,
  },
  ".overlay.active": { "@apply ds-block": true },
});
